import type { VoidFunctionComponent } from 'react';

import { LabeledSelect } from '../../generic';
import { useReportFormatSelector } from '../hooks/useFormatSelector';
import type { AnyReportFormatOption } from '../types';

import styles from './FormatSelector.module.less';

/**
 * Dropdown which allows the user to select the format of the report.
 */
export const FormatSelector: VoidFunctionComponent = () => {
  const { options, value, setFormat } = useReportFormatSelector();
  return (
    <div className={styles.formatSelector}>
      <LabeledSelect<AnyReportFormatOption>
        id="report-format"
        label="Format"
        value={value}
        options={options}
        onChange={setFormat}
      />
    </div>
  );
};
